<!--
/****************************************************************************************************************
* ©2018 EdgeVerve Systems Limited, Bangalore, India. All Rights Reserved.
*
* The EdgeVerve proprietary software program ("Program"), is protected by copyrights laws, international treaties and
* other pending or existing intellectual property rights in India, the United States and other countries. The Program
* may contain / reference third party or open source components, the rights to which continue to remain with the
* applicable third party licensors or the open source community as the case may be and nothing here transfers the
* rights to the third party and open source components, except as expressly permitted. Any unauthorized reproduction,
* storage, transmission in any form or by any means (including without limitation to electronic, mechanical, printing,
* photocopying, recording or otherwise), or any distribution of this Program, or any portion of it, may result in
* severe civil and criminal penalties, and will be prosecuted to the maximum extent possible under the law.
*****************************************************************************************************************/
-->
<div class="header-text">{{data.title}}</div>
@if (data && data.content) {
  <div style="display: flex; flex-direction: row; flex-wrap: wrap; align-self: stretch" class="component-list">
    @for (component of data.content; track component) {
      <div style="flex: 1 1 50%; max-width: 50%; box-sizing: border-box" class="component-item" (click)="saveComponent(component)">
        <div class="item-content">{{component.displayName || component.name}}</div>
      </div>
    }
  </div>
}
<div class="dialog-footer">
  <button mat-button mat-raised-button (click)="cancel()">Cancel</button>
</div>


